import { PosTheme, PosThemeKey, PosThemeMode } from '@adminpages/domain-models';

const defaultDarkTheme = {
  backgroundColor: '#0f172a',
  surfaceColor: '#182230',
  textColor: '#f8fafc',
  mutedColor: '#cbd5e1',
  borderColor: 'rgba(255, 255, 255, 0.12)',
  shadowColor: 'rgba(0, 0, 0, 0.34)',
  inputColor: '#111827',
};

export const posThemes: Record<PosThemeKey, PosTheme> = {
  default: {
    key: 'default',
    name: 'Default',
    primaryColor: '#2563eb',
    accentColor: '#f59e0b',
    backgroundColor: '#f8fafc',
    surfaceColor: '#ffffff',
    textColor: '#111827',
    dark: defaultDarkTheme,
  },
  universo: {
    key: 'universo',
    name: 'Universo Infantil',
    primaryColor: '#e85d9e',
    accentColor: '#2ca6a4',
    backgroundColor: '#fdf7fb',
    surfaceColor: '#ffffff',
    textColor: '#182230',
    dark: {
      ...defaultDarkTheme,
      backgroundColor: '#1f1520',
      surfaceColor: '#2a1d2b',
      inputColor: '#201623',
    },
  },
  taly: {
    key: 'taly',
    name: 'Pollos Taly',
    primaryColor: '#d92d20',
    accentColor: '#f79009',
    backgroundColor: '#fff8ed',
    surfaceColor: '#ffffff',
    textColor: '#1f1308',
    dark: {
      ...defaultDarkTheme,
      backgroundColor: '#20130b',
      surfaceColor: '#2c1b11',
      inputColor: '#1c120b',
    },
  },
};

export function resolvePosThemeMode(mode: PosThemeMode): 'light' | 'dark' {
  if (mode !== 'system') {
    return mode;
  }

  if (typeof window === 'undefined') {
    return 'light';
  }

  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

export function applyPosTheme(theme: PosTheme, mode: PosThemeMode = 'light'): void {
  const root = document.documentElement;
  const resolvedMode = resolvePosThemeMode(mode);
  const colors = resolvedMode === 'dark' && theme.dark ? theme.dark : theme;

  root.style.setProperty('--pos-color-primary', theme.primaryColor);
  root.style.setProperty('--pos-color-accent', theme.accentColor);
  root.style.setProperty('--pos-color-background', colors.backgroundColor);
  root.style.setProperty('--pos-color-surface', colors.surfaceColor);
  root.style.setProperty('--pos-color-text', colors.textColor);
  root.style.setProperty('--pos-color-muted', colors.mutedColor ?? '#667085');
  root.style.setProperty('--pos-color-border', colors.borderColor ?? 'rgba(24, 34, 48, 0.08)');
  root.style.setProperty('--pos-color-shadow', colors.shadowColor ?? 'rgba(24, 34, 48, 0.08)');
  root.style.setProperty('--pos-color-input', colors.inputColor ?? '#f8fafc');
  root.style.setProperty('--ion-background-color', colors.backgroundColor);
  root.style.setProperty('--ion-text-color', colors.textColor);
  root.dataset['posThemeMode'] = resolvedMode;
}

export function formatMoney(value: number, currency = 'MXN'): string {
  return new Intl.NumberFormat('es-MX', {
    style: 'currency',
    currency,
  }).format(value);
}
